var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseOrangeBorder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13258",
    "data-name": "Group 13258",
    transform: "translate(-103 -497)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_569",
    "data-name": "Ellipse 569",
    transform: "translate(103 497)",
    fill: "#fff",
    stroke: "#111",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 7.25,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_45330",
    "data-name": "Path 45330",
    d: "M676.807,675.5c.045-.043.084-.078.121-.115l2.155-2.154a.539.539,0,0,1,.934.271.554.554,0,0,1-.193.51q-1.069,1.065-2.134,2.133c-.037.037-.072.077-.114.121.043.045.078.084.115.122q1.067,1.067,2.134,2.133a.554.554,0,0,1,.192.511.522.522,0,0,1-.362.423.5.5,0,0,1-.541-.125c-.266-.258-.526-.523-.789-.786l-1.513-1.514c-.042.039-.081.072-.117.109q-1.078,1.077-2.155,2.153a.538.538,0,1,1-.788-.731c.227-.235.462-.464.693-.695l1.481-1.481c.037-.037.072-.076.115-.121-.043-.045-.079-.084-.116-.121q-1.067-1.067-2.134-2.133a.545.545,0,0,1-.187-.538.532.532,0,0,1,.884-.282c.146.13.279.273.417.411l1.782,1.781c.037.037.076.073.121.116",
    transform: "translate(-566.311 -171.768)",
    fill: "#ef7b13"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseOrangeBorder);
export default __webpack_public_path__ + "static/media/close_orange_border.8faa7e44fe9c05e2cb917d5a3c8dd8a9.svg";
export { ForwardRef as ReactComponent };